// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const NextNavIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}>
		<defs>
			<linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="NextNavIcon_tsx__a">
				<stop stopColor="#9191FF" offset="0%" />
				<stop stopColor="#F075C7" offset="100%" />
			</linearGradient>
		</defs>
		<g transform="matrix(-1 0 0 1 60 0)" fill="none" fillRule="evenodd">
			<circle fill="url(#NextNavIcon_tsx__a)" cx={30} cy={30} r={30} />
			<path fill="#FFF" fillRule="nonzero" d="M34.344 22.344 26.687 30l7.657 7.656L32 40 22 30l10-10z" />
		</g>
	</svg>
);
export default NextNavIcon;
